import { ModulesEnum } from "../../models/enum/ModulesEnum";
import {
  IconDocument,
  IconHome,
  IconPencil,
  IconPeople,
  IconLightbulb,
  IconMarketplace,
  IconRibbon,
  IconImageEditPreview,
  IconDocumentSignature,
  IconCalendarClock,
  IconNote,
  IconCalendarMonth,
  IconBarChart,
  IconArchive,
  IconAllInOne,
} from "@veneer/core";

const modulesRoutes = new Map([
  [
    ModulesEnum.HomeTab,
    { route: "/", name: "header.home", icon: <IconHome /> },
  ],
  [
    ModulesEnum.AgendaTab,
    { route: "/agendas", name: "header.agenda", icon: <IconDocument /> },
  ],
  [
    ModulesEnum.AdvisorManagement,
    { route: "/", name: "", icon: <IconDocument /> },
  ],
  [
    ModulesEnum.UserManagement,
    {
      route: "/users",
      route2: "/users_management_massive",
      name: "header.userManagement",
      icon: <IconPeople />,
    },
  ],
  [
    ModulesEnum.ActivationManagement,
    {
      route: "/activations",
      route2: "/activationsAssignation",
      route3: "/bulkActivationsAssignation",
      name: "header.activations",
      icon: <IconPencil />,
    },
  ],
  [
    ModulesEnum.AgendaManagement,
    {
      route: "/scheduling_agendas",
      route2: "/scheduling_agendas_files",
      route3: "/appointmentControl",
      name: "header.agendaManagement",
      icon: <IconDocument />,
    },
  ],
  [
    ModulesEnum.LearningTab,
    {
      route: "/courses",
      route2: "/colleagues",
      route3: "/trainingLibrary",
      route4: "/emblems",
      name: "header.learning",
      icon: <IconLightbulb />,
    },
  ],
  [
    ModulesEnum.BrandsTab,
    { route: "/brands", name: "header.brands", icon: <IconMarketplace /> },
  ],
  [
    ModulesEnum.SellOut,
    {
      route: "/sellOut",
      route2: "/scorecard",
      name: "SellOut",
      icon: <IconDocument />,
    },
  ],
  [
    ModulesEnum.Surveys,
    { route: "/surveys", name: "header.surveys", icon: <IconRibbon /> },
  ],
  [
    ModulesEnum.ExecutionManagement,
    {
      route: "/executionManagement",
      name: "header.executionManagement",
      icon: <IconDocument />,
    },
  ],
  [
    ModulesEnum.Reports,
    {
      route: "/reports",
      name: "header.reports",
      icon: <IconDocumentSignature />,
    },
  ],
  // [ModulesEnum.PosManagement, { route: '/posManagement', name: "header.pointOfSale", icon: <IconNote /> }],
  [
    ModulesEnum.SubRetailManagement,
    {
      route: "/posManagement",
      route2: "/subRetailManagement",
      name: "subRetailManagement.title",
      icon: <IconNote />,
    },
  ],
  [
    ModulesEnum.AttendanceControl,
    {
      route: "/attendance",
      route2: "/attendanceRoute",
      name: "header.attendance",
      icon: <IconCalendarClock />,
    },
  ],
  [
    ModulesEnum.VisualExecution,
    {
      route: "/visualExecution",
      name: "header.visualExecution",
      icon: <IconImageEditPreview />,
    },
  ],
  [
    ModulesEnum.CourseManagement,
    {
      route: "/coursesManagement",
      name: "header.coursesManagement",
      icon: <IconImageEditPreview />,
    },
  ],
  [
    ModulesEnum.Absences,
    {
      route: "/absences",
      route2: "/massive-absences",
      name: "header.absences",
      icon: <IconCalendarMonth />,
    },
  ],
  [
    ModulesEnum.TrainingMaterial,
    {
      route: "/trainingMaterial",
      name: "header.trainingMaterial",
      icon: <IconArchive />,
    },
  ],
  [
    ModulesEnum.ProductsManagement,
    {
      route: "/productsManagement",
      name: "header.productsManagement",
      icon: <IconAllInOne />,
    },
  ],
  [
    ModulesEnum.Metrics,
    {
      route: "/metrics",
      route2: "/metricsRealTime",
      route3: "/metricsRanking",
      name: "header.metrics",
      icon: <IconBarChart />,
    },
  ],
  [
    ModulesEnum.CheckInVsAbsence,
    {
      route: "/checkInVsAbsence",
      name: "header.checkInVsAbsence",
      icon: <IconArchive />,
    },
  ],
  [
    ModulesEnum.JustificationAbsences,
    {
      route: "/justification-absences",
      name: "header.justificationAbsences",
      icon: <IconDocumentSignature />,
    },
  ],
]);

export default modulesRoutes;
